import ContentGrid from 'components/ContentGrid'
import Grid from 'components/Grid'
import { Centered } from 'components/Grid/Grid'
import styled from 'styled-components'

export const _TextWidth = styled.div`
font-family: var(--font-serif);
line-height: 24px;
  // MOBILE
  grid-column: 1/-1;

  // MOBILE LANDSCAPE
  @media only screen and (min-width: 712px) {
    grid-column: 2 / span 6;
  }

  // DESKTOP
  @media only screen and (min-width: 1072px) {
    grid-column: 3 / span 8;
  }
  // DESKTOP LARGE
  @media only screen and (min-width: 1680px) {
    grid-column: 4 / span 6;
  }
  ._left {
    display: inline-block;
    width: 100%;

    @media only screen and (min-width: 712px) {
      width: calc(50% - 1.2rem);
      margin-right: 2.4rem;
    }
    @media only screen and (min-width: 1024px) {
      width: calc(50% - 1.4rem);
      margin-right: 2.8rem;
    }
  }
  ._right {
    display: inline-block;
    width: 100%;

    @media only screen and (min-width: 712px) {
      width: calc(50% - 1.2rem);
    }

    @media only screen and (min-width: 1024px) {
      width: calc(50% - 1.4rem);
    }
  }
`
export const TextWidth = ({
  children,
}: {
  children: JSX.Element[] | JSX.Element | string
}) => {
  return (
    <Grid>
      <_TextWidth>{children}</_TextWidth>
    </Grid>
  )
}

export const _TextWidthExtended = styled.div`
  // MOBILE
  grid-column: 1/-1;

  // MOBILE LANDSCAPE
  @media only screen and (min-width: 712px) {
    grid-column: 1 / span 8;
  }

  // DESKTOP
  @media only screen and (min-width: 1072px) {
    grid-column: 2 / span 10;
  }
  // DESKTOP LARGE
  @media only screen and (min-width: 1680px) {
    grid-column: 3 / span 8;
  }
  ._left {
    display: inline-block;
    width: 100%;

    @media only screen and (min-width: 712px) {
      width: calc(50% - 1.2rem);
      margin-right: 2.4rem;
    }
    @media only screen and (min-width: 1024px) {
      width: calc(50% - 1.4rem);
      margin-right: 2.8rem;
    }
  }
  ._right {
    display: inline-block;
    width: 100%;

    @media only screen and (min-width: 712px) {
      width: calc(50% - 1.2rem);
    }

    @media only screen and (min-width: 1024px) {
      width: calc(50% - 1.4rem);
    }
  }
`

export const TextWidthExtended = ({
  children,
}: {
  children: JSX.Element[] | JSX.Element | string
}) => {
  return (
    <Grid>
      <_TextWidthExtended>{children}</_TextWidthExtended>
    </Grid>
  )
}

export const _Left = styled.div``
export const Left = ({
  children,
}: {
  children: JSX.Element[] | JSX.Element | string
}) => {
  return <_Left className='_left'>{children}</_Left>
}

export const _LeftAndText = styled.div`
  margin-right: 2rem;
  grid-column: 1 / span 2;
  margin-left: calc(((100vw - 1015px) / 2) * -1);
  @media only screen and (min-width: 541px) {
    margin-right: calc((100vw - 540px) / 2 + 2.4rem);
  }
  @media only screen and (min-width: 712px) {
    margin-right: calc(2 * (100vw / 12) - 1.2rem);
  }
  @media only screen and (min-width: 832px) {
    margin-right: calc((100vw - 928px) / 2 + 2 * (928px / 12) + 1.8rem);
  }
  @media only screen and (min-width: 1072px) {
    margin-right: calc((100vw - 1015px) / 2 + 2 * (1015px / 12) + 0.5rem);
  }
  @media only screen and (min-width: 1222px) {
    /* margin-left: calc((100vw - 1015px) / 2 - 2.8rem); */
    margin-right: calc((100vw - 1015px) / 2 + 2 * (1015px / 12) + 0.5rem);
  }
`
export const LeftAndText = ({
  children,
}: {
  children: JSX.Element[] | JSX.Element | string
}) => {
  return (
    <Centered>
      <_LeftAndText>{children}</_LeftAndText>
    </Centered>
  )
}

export const RightAndText = styled.div`
  margin-left: 2rem;
  @media only screen and (min-width: 541px) {
    margin-left: calc((100vw - 540px) / 2 + 2.4rem);
  }
  @media only screen and (min-width: 712px) {
    margin-left: calc(2 * (100vw / 12) - 1.2rem);
  }
  @media only screen and (min-width: 832px) {
    margin-left: calc((100vw - 928px) / 2 + 2 * (928px / 12) + 1.8rem);
  }
  @media only screen and (min-width: 1072px) {
    margin-left: calc((100vw - 1015px) / 2 + 2 * (1015px / 12) + 0.5rem);
  }
`
export const _Right = styled.div``
export const Right = ({
  children,
}: {
  children: JSX.Element[] | JSX.Element | string
}) => {
  return <_Right className='_right'>{children}</_Right>
}
export const _ContentWidth = styled.div`
  grid-column: 1/-1;

  ._left {
    display: inline-block;
    width: 100%;

    @media only screen and (min-width: 712px) {
      width: calc(50% - 1.2rem);
      margin-right: 2.4rem;
    }
    @media only screen and (min-width: 1024px) {
      width: calc(50% - 1.4rem);
      margin-right: 2.8rem;
    }
  }
  ._right {
    display: inline-block;
    width: 100%;

    @media only screen and (min-width: 712px) {
      width: calc(50% - 1.2rem);
    }

    @media only screen and (min-width: 1024px) {
      width: calc(50% - 1.4rem);
    }
  }
`
export const ContentWidth = ({
  children,
}: {
  children: (JSX.Element | string)[] | JSX.Element | string
}) => {
  return (
    <Grid>
      <_ContentWidth>{children}</_ContentWidth>
    </Grid>
  )
}
